import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'ProductLot',
  props: {
    lot: {
      type: Number,
      required: true
    },
    unitAmount: {
      type: String,
      required: true
    }
  },
  computed: {
    formattedLot: function formattedLot() {
      return this.$t('lot', {
        x: this.lot,
        unit_amount: this.unitAmount
      });
    }
  }
};